import React from 'react';
import { profileInfo } from '../data/socialLinks';
import './Profile.css';

const Profile = () => {
    return (
        <header className="header">
            <div className="profile minimal">
                <div className="avatar">
                    <a href="https://sacco-auto.fr" target="_blank" rel="noopener noreferrer" draggable={false} onDragStart={(e) => e.preventDefault()}>
                        <img 
                            src={profileInfo.logo} 
                            alt={`Logo ${profileInfo.name}`}
                            className="logo-image"
                            draggable={false}
                            onDragStart={(e) => e.preventDefault()}
                        />
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Profile;